import type { ValueCard } from "../types";

/** "Engineering leadership" — lead-level engineering strengths. */
export const leadership: ValueCard[] = [
  {
    id: "direction",
    icon: "layers",
    title: {
      en: "Technical direction & architecture",
      ru: "Техническое направление и архитектура",
    },
    text: {
      en: "I set the technical direction and own architecture end to end — modular MVI/MVVM with Clean Architecture, Coroutines and Jetpack Compose — keeping the codebase clean and scalable.",
      ru: "Задаю техническое направление и держу всю архитектуру — модульная MVI/MVVM с Clean Architecture, Coroutines и Jetpack Compose. Код остаётся чистым, и его легко развивать.",
    },
  },
  {
    id: "quality",
    icon: "shield-check",
    title: {
      en: "Quality bar & testing",
      ru: "Планка качества и тесты",
    },
    text: {
      en: "I hold the quality bar with test-first development — JUnit 4/5, Espresso, Kaspresso, Robolectric — and CI/CD pipelines that keep releases reliable.",
      ru: "Держу планку качества: разработка через тесты — JUnit 4/5, Espresso, Kaspresso, Robolectric — и CI/CD, чтобы релизы были стабильными.",
    },
  },
  {
    id: "delivery",
    icon: "code",
    title: {
      en: "Delivery ownership",
      ru: "Ответственность за релиз",
    },
    text: {
      en: "I lead delivery from idea to production — scoping, estimating and shipping — and stay accountable for what goes live.",
      ru: "Веду продукт от идеи до продакшена — оценка, планирование, релиз — и отвечаю за то, что уходит в прод.",
    },
  },
  {
    id: "product",
    icon: "target",
    title: {
      en: "Cross-platform & product",
      ru: "Кросс-платформа и продукт",
    },
    text: {
      en: "Deep Android with iOS (Swift), Flutter and KMM breadth — I guide mobile decisions and match the right tool to product goals, not to hype.",
      ru: "Сильная база в Android плюс iOS (Swift), Flutter и KMM. Помогаю с мобильными решениями и подбираю инструмент под задачи продукта, а не под хайп.",
    },
  },
];
